module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image22.b5313301.webp";